import React, { FC, forwardRef } from 'react';
import { Entry } from '@trip-ux/components';
import { GenericInputType } from './GenericInputType';

export const GenericInput: FC<GenericInputType> = forwardRef(({ input, inputOnChange, meta, ...rest }, ref) => (
  <div>
    <Entry
      {...input}
      {...rest}
      onChange={val => {
        input.onChange(val);
        inputOnChange && inputOnChange(val);
      }}
      ref={ref}
    />
  </div>
));
GenericInput.displayName = 'GenericInput';